module.exports = __webpack_public_path__ + "img/wonderbabylon_tech_Normal_ua.19245616.webp";